export const Divider = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 302 2" fill="none">
    <path d="M1 1L301 0.999974" strokeLinecap="round" className="stroke-neutral-300" />
  </svg>
)
